import styled from "styled-components";

import { fontSizes } from "../../shared/styles/typography";
import { pageRoot } from "../../styles/pageRoot";

export const Container = styled.div`
  ${pageRoot}
  padding: 16px;
  gap: 20px;
  justify-content: center;
`;

export const CommunityCard = styled.div`
  background: #fff;
  border-radius: 24px;
  padding: 32px 24px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;

  .icon-box {
    width: 88px;
    height: 88px;
    border-radius: 44px;
    background: #5f33e1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-bottom: 8px;
  }

  h2 {
    font-size: ${fontSizes.xl}px;
    font-weight: var(--font-weight-bold);
    color: #1e293b;
    margin: 0;
  }

  .badge {
    background: rgba(95, 51, 225, 0.1);
    color: #5f33e1;
    padding: 8px 16px;
    border-radius: 12px;
    font-weight: var(--font-weight-semibold);
    font-size: ${fontSizes.sm}px;
  }

  p {
    font-size: ${fontSizes.base}px;
    color: #64748b;
    line-height: 1.6;
    margin: 0;
  }
`;

export const SubscribeBox = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CheckboxRow = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 16px;
  background: ${(props) =>
    props.$active ? "rgba(95, 51, 225, 0.1)" : "#f8fafc"};
  border: 1px solid ${(props) => (props.$active ? "#5F33E1" : "transparent")};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba(95, 51, 225, 0.05);
  }

  .checkbox {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: 2px solid ${(props) => (props.$active ? "#5F33E1" : "#cbd5e1")};
    background: ${(props) => (props.$active ? "#5F33E1" : "transparent")};
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  span {
    font-size: ${fontSizes.base}px;
    font-weight: 600;
    color: ${(props) => (props.$active ? "#5f33e1" : "#1e293b")};
    text-align: left;
    flex: 1;
  }
`;
